(function() {
  'use strict';
  
  let lastVariantId = null;
  let skioPlanPicker = null;
  
  // Helper to format money
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  
  // Get the Skio plan picker element
  function getSkioPlanPicker() {
    if (!skioPlanPicker) {
      skioPlanPicker = document.querySelector('skio-plan-picker');
    }
    return skioPlanPicker;
  }
  
  // Update sticky price from Skio's internal state
  function updateStickyPriceFromSkio() {
    console.log('🔄 Updating sticky price from Skio...');
    
    const picker = getSkioPlanPicker();
    if (!picker) {
      console.warn('⚠️ Skio plan picker not found');
      return;
    }
    
    // Get Skio's selected variant and selling plan
    const selectedVariant = picker.selectedVariant;
    const selectedSellingPlan = picker.selectedSellingPlan;
    
    if (!selectedVariant) {
      console.warn('⚠️ No variant selected');
      return;
    }
    
    const oneTimePrice = formatMoney(selectedVariant.price);
    
    // Check if subscription is selected
    if (selectedSellingPlan) {
      // Get subscription price from Skio's price() method
      const subscriptionPrice = picker.price(selectedSellingPlan, true); // formatted
      const groupName = picker.selectedSellingPlanGroup?.name || 'Subscribe & Save';
      
      console.log('✅ Subscription selected:', {
        subscriptionPrice,
        oneTimePrice,
        groupName
      });
      
      // Update purchase text
      const purchaseTextEl = document.querySelector('.purchase-text');
      if (purchaseTextEl) {
        purchaseTextEl.textContent = groupName;
      }
      
      // Update sticky variant price with compare price
      const stickyPriceEl = document.querySelector('#sticky-variant-price');
      if (stickyPriceEl) {
        stickyPriceEl.innerHTML = `
          <span class="price">${subscriptionPrice}</span>
          <span class="compare-price" style="text-decoration:line-through; opacity:0.6; margin-left:6px;">${oneTimePrice}</span>
        `;
      }
      
      // Update button pricing
      const buttonPricingEl = document.querySelector('.button-pricing span');
      if (buttonPricingEl) {
        buttonPricingEl.textContent = subscriptionPrice;
      }
      
      // Update hidden inputs
      const purchaseInput = document.getElementById('purchase-text-input');
      const priceInput = document.getElementById('price-input');
      if (purchaseInput) purchaseInput.value = groupName;
      if (priceInput) priceInput.value = subscriptionPrice;
      
    } else {
      // One-time purchase selected
      console.log('✅ One-time purchase selected:', oneTimePrice);
      
      // Update purchase text
      const purchaseTextEl = document.querySelector('.purchase-text');
      if (purchaseTextEl) {
        purchaseTextEl.textContent = 'One Time Purchase';
      }
      
      // Update sticky variant price
      const stickyPriceEl = document.querySelector('#sticky-variant-price');
      if (stickyPriceEl) {
        stickyPriceEl.innerHTML = `<span class="price">${oneTimePrice}</span>`;
      }
      
      // Update button pricing
      const buttonPricingEl = document.querySelector('.button-pricing span');
      if (buttonPricingEl) {
        buttonPricingEl.textContent = oneTimePrice;
      }
      
      // Update hidden inputs
      const purchaseInput = document.getElementById('purchase-text-input');
      const priceInput = document.getElementById('price-input');
      if (purchaseInput) purchaseInput.value = 'One Time Purchase';
      if (priceInput) priceInput.value = oneTimePrice;
    }
  }
  
  // Handle variant changes
  function handleVariantChange(variantIdOrTitle) {
    if (lastVariantId === variantIdOrTitle) return;
    lastVariantId = variantIdOrTitle;
    
    console.log('🎯 Variant changed to:', variantIdOrTitle);
    
    const picker = getSkioPlanPicker();
    if (!picker || !picker.product) {
      console.warn('⚠️ Skio not ready yet');
      return;
    }
    
    // Try to find variant by ID first, then by title/option
    let newVariant = picker.product.variants.find(v => v.id == variantIdOrTitle);
    
    // If not found by ID, try to find by option value (for GemPages)
    if (!newVariant) {
      newVariant = picker.product.variants.find(v => {
        return v.title === variantIdOrTitle || 
               v.option1 === variantIdOrTitle ||
               v.option2 === variantIdOrTitle ||
               v.option3 === variantIdOrTitle;
      });
    }
    
    if (!newVariant) {
      console.warn('⚠️ Variant not found:', variantIdOrTitle);
      return;
    }
    
    console.log('✅ Found variant:', newVariant.title, 'ID:', newVariant.id);
    
    // Update Skio's selected variant
    picker.selectedVariant = newVariant;
    
    // Wait for Skio to update its internal state
    setTimeout(() => {
      updateStickyPriceFromSkio();
    }, 100);
  }
  
  // Initialize when Skio is ready
  function initSkioIntegration() {
    const picker = getSkioPlanPicker();
    if (!picker) {
      console.log('⏳ Waiting for Skio plan picker...');
      return false;
    }
    
    // Wait for Skio to be fully initialized
    if (!picker.product || !picker.selectedVariant) {
      console.log('⏳ Skio not fully initialized yet...');
      return false;
    }
    
    console.log('✅ Skio plan picker found and ready');
	
    
    // Listen to Skio's custom update event
    picker.addEventListener('skio::update-selling-plan', function(e) {
      console.log('🎯 Skio selling plan updated:', e.detail);
      setTimeout(() => {
        updateStickyPriceFromSkio();
      }, 50);
    });
    
    // Listen to Skio input changes (for radio buttons)
    const skioInputs = picker.querySelectorAll('input[name^="skio-group-"]');
    skioInputs.forEach(input => {
      input.addEventListener('change', function() {
        console.log('🎯 Skio radio changed');
        setTimeout(() => {
          updateStickyPriceFromSkio();
        }, 50);
      });
    });
    
    // Listen to frequency dropdown changes
    const frequencySelects = picker.querySelectorAll('.selling-plan-dropdown');
    frequencySelects.forEach(select => {
      select.addEventListener('change', function() {
        console.log('🎯 Skio frequency changed');
        setTimeout(() => {
          updateStickyPriceFromSkio();
        }, 50);
      });
    });
    
    // Get all possible variant selectors
    const variantSelectors = [
      document.querySelector('select[name="id"]'), // Standard Shopify
      document.querySelector('#SingleOptionSelector-product-0'), // GemPages single option
      document.querySelector('.gf_variants-option1 select'), // GemPages by class
      document.querySelector('.single-option-selector-product') // GemPages by class
    ].filter(Boolean); // Remove null values
    
    // Watch for variant changes via the theme's event
    document.addEventListener('l:variant:changed', function() {
      const variantInput = variantSelectors[0];
      if (variantInput && variantInput.value) {
        console.log('🎯 Theme variant:changed event');
        handleVariantChange(variantInput.value);
      }
    });
    
    // Set up listeners for all variant selectors found
    variantSelectors.forEach((variantInput, index) => {
      console.log(`✅ Setting up listeners for variant selector ${index + 1}`);
      
      // Direct change listener
      variantInput.addEventListener('change', function() {
        console.log('🎯 Variant input changed:', this.value);
        handleVariantChange(this.value);
      });
      
      // MutationObserver for programmatic changes
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            handleVariantChange(variantInput.value);
          }
        });
      });
      
      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });
      
      // Poll for changes (backup method)
      let lastValue = variantInput.value;
      setInterval(() => {
        if (variantInput.value !== lastValue) {
          lastValue = variantInput.value;
          handleVariantChange(lastValue);
        }
      }, 300);
    });
    
    // Initial update
    setTimeout(() => {
      updateStickyPriceFromSkio();
    }, 500);
    
    return true;
  }
  
  // Check for Skio repeatedly until found
  let checkCount = 0;
  const maxChecks = 50; // 5 seconds
  const checkInterval = setInterval(function() {
    checkCount++;
    
    if (initSkioIntegration()) {
      clearInterval(checkInterval);
      console.log('✅ Skio integration initialized successfully');
    } else if (checkCount >= maxChecks) {
      clearInterval(checkInterval);
      console.error('❌ Failed to initialize Skio integration after 5 seconds');
    }
  }, 100);
  
  // Also try on DOMContentLoaded and window load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initSkioIntegration, 500);
    });
  }
  
  window.addEventListener('load', function() {
    setTimeout(initSkioIntegration, 500);
  });
  
})();